import dynamic from "next/dynamic";

export const BlockQuoteSideImage = dynamic(() => import("./component"));
